import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AuthGuard, AuthGuardChild } from './core/auth';
import { HomeComponent } from './home/home.component';
import { ErrorPageComponent } from './content/pages/snippets/error-page/error-page.component';

const routes: Routes = [
	{ path: 'pages', loadChildren: 'app/content/pages/pages.module#PagesModule' },
	{ path: 'login', loadChildren: './core/auth/auth.module#AuthModule' },
	{ path: '404', component: ErrorPageComponent },
	{ path: '?', canActivate: [AuthGuard], component: HomeComponent },
	{ path: '', canActivate: [AuthGuard], component: HomeComponent },
	{ path: '**', redirectTo: '404', pathMatch: 'full' },
];

@NgModule({
	imports: [RouterModule.forRoot(routes, { useHash: true })],
	exports: [RouterModule]
})
export class AppRoutingModule { }
